import React, { useEffect, useState } from 'react';
import { HeaderBox } from './MobileBookPage';
import ProfileService from "../../Services/Profile";
import i18n from '../../i18n';
import { Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useTranslation } from 'react-i18next';
import defaultBook from "../../Images/defaultBook.svg";
import ArticleDummyImg from "../../Images/Image/article.png";

// Reusable Favorite Section
const FavoriteSection = ({ title, viewAllText, items, imageKey, onViewAllClick }: any) => {
  const handleImageError = (e: any) => {
    const target = e.target;
    target.src = defaultBook;
    target.onerror = null;
  };

  if (!items || items.length === 0) return null;

  return (
    <div style={{ backgroundColor: 'white', margin: '6px 6px 0 6px', borderRadius: '4px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '6px' }}>
        <Typography style={{ paddingTop: 8, paddingLeft: 14, fontWeight: 'bold' }}>{title}</Typography>
        {onViewAllClick && (
          <div
            style={{
              backgroundColor: "#f97316",
              padding: '5px 10px',
              height: 30,
              borderRadius: 3,
              color: "white",
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'chanakyaUni',
              cursor: 'pointer',
              fontSize: '14px'
            }}
            onClick={onViewAllClick}
          >
            {viewAllText}
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: 10, overflowX: 'auto', padding: 15, scrollbarWidth: "none", msOverflowStyle: "none" }}>
        {items.map((item: any, index: number) => (
          <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
            <img
              src={
                imageKey === "videoThumbPath" && item?.videoId
                  ? `https://img.youtube.com/vi/${item.videoId}/maxresdefault.jpg`
                  : imageKey === "articleThumbPath" && !item[imageKey]
                  ? ArticleDummyImg
                  : item[imageKey] || defaultBook
              }
              height={110}
              onError={handleImageError}
              alt={`${title} ${index}`}
              style={{ borderRadius: '4px' }}
            />
            <Typography variant="caption" sx={{ textAlign: 'center', mt: 0.5, maxWidth: '90px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {item?.name}
            </Typography>
          </Box>
        ))}
      </div>
    </div>
  );
};

const MobileFavoriatePage = () => {
  const [bookFav, setBookFav] = useState([]);
  const [magazineFav, setMagazineFav] = useState([]);
  const [kalyanFav, setKalyanFav] = useState([]);
  const [kalpataruFav, setKalpataruFav] = useState([]);
  const [vivekvanis, setVivekVanis] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ProfileService.getfavData(0, 50);
        const res = await response;
        setBookFav(res?.result?.books || []);
        setMagazineFav(res?.result?.monthlyMagazine || []);
        setKalyanFav(res?.result?.kalyans || []);
        setKalpataruFav(res?.result?.kalyansKalpataru || []);
        setVivekVanis(res?.result?.vivekVanis || []);
        setArticles(res?.result?.articles || []);
        setVideos(res?.result?.videos || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [i18n.language]);

  const handleViewAllBooksClick = () => {};
  const handleViewAllMagazinesClick = () => {};
  const handleViewAllKalyansClick = () => {};
  const handleviewAllArticlesClick = () => {};
  const handleviewAllVideosClick = () => {};

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <HeaderBox>
        <>
          <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
            <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
          </IconButton>
          <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
            <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
          </IconButton>
          <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
            {t("shrihari_tr")}
          </Typography>
          <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
            {t("myFavourites_tr")}
          </Typography>
        </>
      </HeaderBox>

      <Box sx={{ backgroundColor: "#F0F0F0", flexGrow: 1, display: "flex", flexDirection: "column", overflowY: "auto", paddingBottom: '70px' }}>
        <FavoriteSection
          title={t("E_books_tr")}
          viewAllText="View All Books"
          items={bookFav}
          imageKey="bookThumbPath"
          onViewAllClick={handleViewAllBooksClick}
        />
        <FavoriteSection
          title={t("magazine_tr")}
          viewAllText="View All Magazines"
          items={magazineFav}
          imageKey="monthlyMagazineThumbPath"
          onViewAllClick={handleViewAllMagazinesClick}
        />
        <FavoriteSection
          title={t("Kalyan_tr")}
          viewAllText="View All Kalyans"
          items={kalyanFav}
          imageKey="kalyanThumbPath"
          onViewAllClick={handleViewAllKalyansClick}
        />
        <FavoriteSection
          title={t("Kalyan_Kalpataru_tr")}
          viewAllText="View All kalpataru"
          items={kalpataruFav}
          imageKey="kalyanKalpataruThumbPath"
          onViewAllClick={handleViewAllBooksClick}
          />
        <FavoriteSection
          title={t("vivek_vani_tr")}
          viewAllText="View all Vivek vanis"
          items={vivekvanis}
          imageKey="vivekVaniThumbPath"
          onViewAllClick={handleViewAllBooksClick}
        />
        <FavoriteSection
          title={t("Articles_tr")}
          viewAllText="View All Articles"
          items={articles}
          imageKey="articleThumbPath"
          onViewAllClick={handleviewAllArticlesClick}
          />
          <FavoriteSection
          title={t("Video_tr")}
          viewAllText="View All Videos"
          items={videos}
          imageKey="videoThumbPath"
          onViewAllClick={handleviewAllVideosClick}
          />
      </Box>
    </Box>
  );
};

export default MobileFavoriatePage;
